import { GlobalEnumsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt";

export class ItemContext
{
    type: GlobalEnumsAceXfoundportalobjekt;
    id: string;
}